import { render, staticRenderFns } from "./Criar-Evento.vue?vue&type=template&id=6cc7d7f2&scoped=true&"
import script from "./Criar-Evento.vue?vue&type=script&lang=js&"
export * from "./Criar-Evento.vue?vue&type=script&lang=js&"
import style0 from "./Criar-Evento.vue?vue&type=style&index=0&id=6cc7d7f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc7d7f2",
  null
  
)

component.options.__file = "Criar-Evento.vue"
export default component.exports